<template>
  <card class="card">
    <div class="card-body">
      <h2 class="pt-0 mt-0">
        <i class="fas fa-user text-primary"></i>{{$t('customer.addcustomer')}}
      </h2>
      <hr>
      <div>
        <form @submit.prevent>
          <div class="row">
            <div class="col-md-12">
              <fg-input type="text" :label="$t('customer.name')" :placeholder="$t('customer.name')" v-model="form.user.name"></fg-input>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <fg-input type="email" :label="$t('customer.email')" :placeholder="$t('customer.email')" v-model="form.user.email"></fg-input>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <label class="typo__label">{{$t('customer.documenttype')}}</label>
              <multiselect
                v-model="multiselect"
                :options="doc_types"
                :placeholder="$t('customer.text.selectone')"
                label="name"
                track-by="id"
                @input="selectDocumentType"
              ></multiselect>
            </div>
            <div class="col-md-6">
              <fg-input type="text" :label="$t('customer.documentnumber')" v-model="form.document_number"></fg-input>
            </div>
          </div>
          <br>
          <fg-address v-model="form.addresses"></fg-address>
          <br>
          <fg-phone v-model="form.phones"></fg-phone>
          <br>
          <div class="text-left">
            <p-button type="primary" @click.native.prevent="save">{{$t('customer.button.save')}}</p-button>
          </div>
          <div class="clearfix"></div>
        </form>
      </div>
    </div>
  </card>
</template>
<script>
import { mapState } from "vuex";
import Multiselect from "vue-multiselect";
export default {
  components: {
    Multiselect
  },
  data() {
    return {
      multiselect: null,
      form: {
        user: { name: "", email: "" },
        document_type: "",
        document_number: "",
        addresses: [],
        phones: []
      }
    };
  },
  computed: {
    ...mapState("customers", {
      customer: "customer"
    }),
    doc_types() {
      return this.$store.getters["customers/getDocTypes"];
    }
  },
  methods: {
    selectDocumentType(option) {
      this.form.document_type = option.name;
    },
    save() {
      this.$store.commit("customers/set", this.form);
      this.$store
        .dispatch("customers/add", this.form)
        .then(response => {
          this.$store.dispatch("customers/getAll");
          this.$root.$emit("bv::hide::modal", "AddCustomer");
        })
        .catch(error => {
          let msg = "";
          if (error.response.data) {
            msg = error.response.data.errors[0].detail;
          } else {
            msg = error.response.message;
          }
          this.$notify({
            type: "danger",
            horizontalAlign: "center",
            message: msg
          });
        });
    }
  },
  created() {
    this.$store.dispatch("customers/getDocTypes");
  }
};
</script>
<style>
</style>
